var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-base-list',{attrs:{"funcs":_vm.funcs,"idPage":_vm.idPage,"idPageAlt":_vm.idPageAlt,"pessoaParceiro":_vm.params.nome || null},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var dataset = ref.dataset;
var order = ref.order;
return [_c('c-base-list-item',{attrs:{"dataset":dataset,"idPage":_vm.idPage,"order":order}},[_c('c-valoresPagRec',{attrs:{"dataset":dataset}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }